import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import { EXPLORE } from '../../data/marketingContentAppearance'
import { WHATSON, BESTDEALS } from '../../data/marketingContentSections'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

//TO DO: ADD MOCK

export const getFeatured = (mallSlug, limit = '', appearance) =>
  client({
    method: 'get',
    url: `/marketing-contents/featured`,
    params: {
      mallSlug,
      appearance,
      app: false,
      limit,
    },
  })

export const getWhatsOn = (mallSlug, limit = '') =>
  client({
    method: 'get',
    url: `/marketing-contents`,
    params: {
      mallSlug,
      appearance: EXPLORE,
      section: WHATSON,
      app: false,
      limit,
    },
  })

export const getBestDeals = (mallSlug, limit = '') =>
  client({
    method: 'get',
    url: `/marketing-contents`,
    params: {
      mallSlug,
      appearance: EXPLORE,
      section: BESTDEALS,
      app: false,
      limit,
    },
  })

export const getMarketingContent = id =>
  client({
    method: 'get',
    url: `/marketing-contents/${encodeURIComponent(id)}`,
  })

export const getRelatedArticles = id =>
  client({
    method: 'get',
    url: `/marketing-contents/${encodeURIComponent(id)}/articles`,
    params: {
      limit: 3,
    },
  })
